<template>
  <div>
    <el-row :gutter="10">
      <el-col v-for="(item, index) in sysData"
              :key="index"
              :xs="24"
              :span="6">
        <div class="auth-item mb-10"
             @click="handleTest(item)">
          <p class="card-text"
             :title="item.id">
            <i class="el-icon-discount mr-10"></i>
            序号：{{ item.id }}
          </p>
          <p class="card-text"
             :title="item.name">
            <i class="el-icon-collection-tag mr-10"></i>
            网关名称：{{ item.name }}
          </p>
          <p class="card-text"
             :title="item.area_names">
            <i class="el-icon-collection-tag mr-10"></i>
            所属区域：{{ item.area_names }}
          </p>
          <p class="card-text"
             :title="Number(item.online) === 1?'在线':'离线'">
            <i class="el-icon-collection-tag mr-10"></i>
            在线状态：<el-tag v-if="Number(item.online) === 1"
                    type="success">在线</el-tag>
            <el-tag v-else
                    type="danger">离线</el-tag>
          </p>
        </div>
      </el-col>
    </el-row>
    <Pagination :total="pagination.total"
                :pageSize="pagination.perPage"
                @handleSizeChange="handleSizeChange"
                @handleCurrent="handleCurrentChange"></Pagination>
    <install-test v-if="showConfigModal"
                  :isShow="showConfigModal"
                  :data="conifgData"
                  @handleClose="closeConfigModal"></install-test>
  </div>
</template>

<script>
import fetch from '@/common/api'
import InstallTest from '@/views/device/lockInstall/InstallTest'
import Pagination from '@/components/pagination/Pagination'
export default {
  components: { InstallTest, Pagination },
  data() {
    return {
      sysData: [],
      // 分页相关
      pagination: {
        total: 0,
        currentPage: 1,
        perPage: 12
      },
      // 网关配置相关
      showConfigModal: false,
      conifgData: {}
    }
  },
  created() {
    this.getList()
  },
  methods: {
    getList() {
      const { perPage, currentPage } = this.pagination
      fetch
        .getGateList({
          type: 'old',
          perPage: perPage,
          currentPage: currentPage
        })
        .then((data) => {
          data.procData(
            data.res,
            (data) => {
              this.sysData = data.list
              this.pagination.total = Number(data.total)
            },
            (err) => {
              this.$message.error(err)
            }
          )
        })
    },
    // 分页
    handleSizeChange(val) {
      this.pagination.perPage = val
      this.pagination.currentPage = 1
      this.getList()
    },
    handleCurrentChange(val) {
      this.pagination.currentPage = val
      this.getList()
    },
    handleTest(data) {
      this.showConfigModal = true
      this.conifgData = {
        id: data.id,
        sn: data.sn
      }
    },
    closeConfigModal() {
      this.showConfigModal = false
    }
  }
}
</script>

<style lang="less" scoped>
.auth-item {
  cursor: pointer;
  border-radius: 5px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding: 15px;
  background: #fff;
  border: 1px solid #ebebeb;
  &:hover {
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  }
  i {
    color: #409eff;
  }
}
</style>
